import gaJSON from "../config/googleAnalytics.json"
import { getAnalytics, logEvent, setUserId } from "firebase/analytics"
import {useSelector} from "react-redux";
import {getPersonalInfo} from "../redux/slices/PersonalAccountInformationSlice";

const trackFirebaseAnalytics = ({ event, customParams = undefined }) => {
  try {

    logEvent(getAnalytics(), event, customParams)
  } catch (e) {
    console.error("Google Analytics Error- ", e)
  }
}

const useTrackFirebaseAnalytics = () => {
  const personalInfo = useSelector((state) => getPersonalInfo(state));
  const track = async (event, customParams) => {
    try {
      console.log(personalInfo.id)
      const params = {
        user: personalInfo.id,
        fleet_id: personalInfo.fleet_id,
        ...customParams
      };
      console.log(personalInfo)
      logEvent(getAnalytics(), event, params);
      await new Promise((resolve) => setTimeout(resolve, 5000)); // small delay
    } catch (e) {
      console.error('Google Analytics Error:', e);
    }
  };

  return track;
};

const setFirebaseAnalyticsUserId = (userId) => {
  try {
    setUserId(getAnalytics(), userId.toString())
  } catch (e) {
    console.error("Google Analytics Error- ", e)
  }
}

export {
  trackFirebaseAnalytics,
  useTrackFirebaseAnalytics,
  setFirebaseAnalyticsUserId,
  gaJSON
}
